module.exports = __webpack_public_path__ + "img/header-background-img.102faa4e.png";